<div class="dsh-laptop-grid" fxLayout="column" fxLayoutGap="48px">
    <dsh-toolbar></dsh-toolbar>
    <ng-content></ng-content>
</div>
